import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Alert, Spinner, Container, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const ImportPage = () => {
  const apiPrefix = window.location.pathname.match(/^\/[^\/]+/) ? window.location.pathname.match(/^\/[^\/]+/)[0].replace(/\/$/, '') : '';
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('jwt_token');
        if (!token) {
            navigate('/custom-login');
        }
    }, [navigate]);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
        setError(null);
        setSuccess(false);
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            setError('Please select a file to upload.');
            return;
        }

        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const token = localStorage.getItem('jwt_token');
            if (!token) {
                setError('Authentication token not found. Please log in.');
                setLoading(false);
                return;
            }

            const formData = new FormData();
            formData.append('projectArchive', selectedFile);

            const response = await axios.post(
                '/api/import-project',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setSuccess(true);
            console.log('Import initiated successfully.', response.data);
        } catch (err) {
            console.error('Import failed:', err);
            const errorMessage = err.response?.data?.error || err.message || 'An unknown error occurred during import.';
            setError(errorMessage);
        } finally {
            setLoading(false);
            setSelectedFile(null); // Clear selected file after attempt
        }
    };

    const handleLogout = () => {
        localStorage.removeItem('jwt_token');
        localStorage.removeItem('user');
        navigate('/custom-login');
    };

    return (
        <Container className="mt-5">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>Import Overleaf Project & Data</h2>
                <Button variant="outline-danger" onClick={handleLogout}>Logout</Button>
            </div>
            <p>Upload a zip archive (e.g., from the download feature) to restore your project files and associated database data.</p>

            {error && <Alert variant="danger">{error}</Alert>}
            {success && (
                <Alert variant="success">
                    Import successful! Your project and data have been restored.
                    <div className="mt-2">
                        <Button variant="success" size="sm" onClick={() => window.location.href = '/project'}>
                            Go to Overleaf Projects
                        </Button>
                    </div>
                </Alert>
            )}

            <Form>
                <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>Select Project Archive (.zip)</Form.Label>
                    <Form.Control type="file" accept=".zip" onChange={handleFileChange} />
                </Form.Group>
                <Button
                    variant="primary"
                    onClick={handleUpload}
                    disabled={loading || !selectedFile}
                >
                    {loading ? (
                        <>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            {' '} Uploading & Importing...
                        </>
                    ) : (
                        'Upload & Import Project'
                    )}
                </Button>
            </Form>
        </Container>
    );
};

export default ImportPage;
